import React from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import Popup from '../Popup';
import { commonStyles, COLORS } from '../../styles/styles';
import {
  MDBBtn
} from "mdbreact";

const PagePopup = ({ classes, handlePopupToggle, title, markup }) => (
  <div className={classes.overlay}>
    <Typography className={classes.title}>{title}</Typography>
    <div
      className={classes.content}
      dangerouslySetInnerHTML={{ __html: markup }}
    /> {/* eslint-disable-line react/no-danger */}
    <div className={classes.footer}>
      <MDBBtn
        className="assessmentBtn w-100"
        size="sm"
        color="default"
        onClick={() => { handlePopupToggle(); }}
      >
        Accept
      </MDBBtn>
    </div>
  </div>
);

const styles = () => ({
  ...commonStyles,
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 100000000,
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  image: {
    margin: '0 auto',
    display: 'block',
    maxWidth: 1200,
    width: '98%',
  },
  title: {
    fontSize: 24,
    margin: '24px 40px 16px',
    fontWeight: 'bold',
    flexShrink: 0,
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: '0 40px',
    '& iframe': {
      width: '100%',
      minHeight: 'calc(100vh - 180px)',
      border: '1px solid #ccc',
    },
  },
  footer: {
    flexShrink: 0,
    padding: '16px 40px 24px',
  },
  popupContent: {
    position: 'relative',
    background: COLORS.grey,
    overflow: 'scroll',
    height: 'calc(100% - 64px)',
  },
  popupIframe: {
    boxShadow: '0 4px 5px 0 rgba(0,0,0,0.24)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 10,
  },
  popupHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 64,
  },
  closePopup: {
    color: '#fff',
    background: 'transparent',
    alignSelf: 'flex-end',
    cursor: 'pointer',
    margin: '20px 15px 0 0',
  },
});

export default compose(withStyles(styles))(PagePopup);

PagePopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handlePopupToggle: PropTypes.func,
  markup: PropTypes.string,
  title: PropTypes.string,
};
